import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { cleanData } from 'store/clients';
import { cleanDataQuery, getBalancing } from 'store/balancing';
import {
  getClientSeleted,
  cleanData as cleanDataDocumentary,
} from 'store/documentary';

import { PATH_NAMES_CLEAN_REBALANCING_DATA } from '../constants';
import { getBackUrl, shouldShowBackButton, getPathFlags } from '../helpers';

export const useBackButton = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const clientSeleted = useSelector(getClientSeleted);
  const balancing = useSelector(getBalancing);

  const [showBack, setShowBack] = useState(false);

  const { isPositionsPath, isDocumentary, isCurrentCoOwners } = useMemo(
    () => getPathFlags(location.pathname),
    [location.pathname],
  );

  const backUrl = useMemo(
    () =>
      getBackUrl({
        currentPath: location.pathname,
        isCurrentCoOwners,
        isPositionsPath,
        isDocumentary,
      }),
    [location.pathname, isCurrentCoOwners, isPositionsPath, isDocumentary],
  );

  const flagShouldShowBackButton =
    showBack || isPositionsPath || isCurrentCoOwners;

  const cleanDataByPath = () => {
    try {
      if (!PATH_NAMES_CLEAN_REBALANCING_DATA.includes(location.pathname)) {
        dispatch(cleanDataQuery());
      }
      if (!isDocumentary) {
        dispatch(cleanDataDocumentary());
      }
    } catch (error) {
      console.error('Error cleaning data:', error);
    }
  };

  const handleDocumentaryCase = () => {
    if (isDocumentary) {
      if (!clientSeleted) {
        dispatch(cleanData());
      }
    }
  };

  useEffect(() => {
    setShowBack(false);

    cleanDataByPath();

    const shouldShow = shouldShowBackButton(location.pathname, clientSeleted);
    setShowBack(shouldShow);

    handleDocumentaryCase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, dispatch, balancing, clientSeleted, isPositionsPath]);

  return {
    showBack: flagShouldShowBackButton,
    backUrl,
  };
};
